import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon, Text } from '~/components/atomic';
import { IconButtonWrapper } from '~/components/common';
import { CommentProps } from '../CommentContainer';
import { SortComment } from './CommentInner';

interface CommentInfoProps {
  commentCount: CommentProps['viewComment']['total'];
  setIsCommentOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sortOrder: SortComment;
  toggleSortComments: () => void;
}

export default function CommentInfo({
  commentCount,
  setIsCommentOpen,
  sortOrder,
  toggleSortComments,
}: CommentInfoProps) {
  return (
    <>
      <Container>
        <Wrapper>
          <Text
            as={'strong'}
            fontStyle='poppins.sub_title'
            color='content_light_1'
          >
            Comments
          </Text>

          {!!commentCount && (
            <Text
              as={'span'}
              fontStyle='text.body14_bold'
              color='content_light_1'
            >
              {commentCount}
            </Text>
          )}
        </Wrapper>
        <IconButtonWrapper size={44} onClick={() => setIsCommentOpen(false)}>
          <Icon iconName='Close' size={24} color='content_light_5' />
        </IconButtonWrapper>
      </Container>

      <div>
        <SortContainer onClick={toggleSortComments}>
          <IconButtonWrapper size={16}>
            <Icon size={16} iconName='SwapVert' />
          </IconButtonWrapper>
          {sortOrder === 'newest' ? (
            <Text fontStyle='text.body14_medium' color='content_light_1'>
              Newest
            </Text>
          ) : (
            <Text fontStyle='text.body14_medium' color='content_light_1'>
              Top
            </Text>
          )}
        </SortContainer>
      </div>
    </>
  );
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
`;

export const SortContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    width: fit-content;
    height: 32px;
    padding: 4px 12px 4px 6px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 16px;
    gap: 4px;
  `}
`;
